export default "__VITE_ASSET__5fba42fd__"